export default function getAuthToken(state) {
  return state.authToken;
}
